// extracted by mini-css-extract-plugin
export default {"reset":"ResetPassword_reset__Z7SiL","heading":"ResetPassword_heading__VpCBj","head":"ResetPassword_head__VnrQj","field":"ResetPassword_field__vUed4"};